export default "__VITE_PUBLIC_ASSET__3791dbc7__"